export default "__VITE_ASSET__D4xucV7___"